import React, { useEffect } from 'react';
import type { ReactElement, ReactNode } from 'react';

import { Col } from '@opendoor/atoms/box';
import { useAuth } from '@opendoor/auth-fe/context';
import { useRouter } from 'next/router';

interface BuyDirectCheckoutLayoutProps {
  children: ReactNode;
}

/**
 * Layout component for the Buy Direct Checkout flow.
 * Provides authentication protection and a minimal header.
 */
const BuyDirectCheckoutLayout: React.FC<BuyDirectCheckoutLayoutProps> = ({ children }) => {
  const { authentication } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (authentication.state === 'not_authenticated') {
      window.location.assign(`/login?redirectTo=${encodeURIComponent(router.asPath)}`);
    }
  }, [authentication.state, router.asPath]);

  if (authentication.state === 'not_authenticated') {
    return null;
  }

  return <Col className="min-h-screen bg-od-bg-primary">{children}</Col>;
};

export const getBuyDirectCheckoutLayout = (page: ReactElement) => {
  return <BuyDirectCheckoutLayout>{page}</BuyDirectCheckoutLayout>;
};
